import { render, staticRenderFns } from "./JcdcRatings.vue?vue&type=template&id=c691fca0"
import script from "./JcdcRatings.vue?vue&type=script&lang=ts"
export * from "./JcdcRatings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports